"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSuggestedShiftRateDto = instanceOfSuggestedShiftRateDto;
exports.SuggestedShiftRateDtoFromJSON = SuggestedShiftRateDtoFromJSON;
exports.SuggestedShiftRateDtoFromJSONTyped = SuggestedShiftRateDtoFromJSONTyped;
exports.SuggestedShiftRateDtoToJSON = SuggestedShiftRateDtoToJSON;
exports.SuggestedShiftRateDtoToJSONTyped = SuggestedShiftRateDtoToJSONTyped;
const SuggestedShiftRateMatch_1 = require("./SuggestedShiftRateMatch");
const StipendCreateDto_1 = require("./StipendCreateDto");
/**
 * Check if a given object implements the SuggestedShiftRateDto interface.
 */
function instanceOfSuggestedShiftRateDto(value) {
    if (!('matchedOn' in value) || value['matchedOn'] === undefined)
        return false;
    if (!('totalRate' in value) || value['totalRate'] === undefined)
        return false;
    if (!('onCallTotalRate' in value) || value['onCallTotalRate'] === undefined)
        return false;
    if (!('stipendMinimumDistance' in value) || value['stipendMinimumDistance'] === undefined)
        return false;
    if (!('stipends' in value) || value['stipends'] === undefined)
        return false;
    return true;
}
function SuggestedShiftRateDtoFromJSON(json) {
    return SuggestedShiftRateDtoFromJSONTyped(json, false);
}
function SuggestedShiftRateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'matchedOn': (0, SuggestedShiftRateMatch_1.SuggestedShiftRateMatchFromJSON)(json['matchedOn']),
        'totalRate': json['totalRate'],
        'onCallTotalRate': json['onCallTotalRate'],
        'stipendMinimumDistance': json['stipendMinimumDistance'],
        'stipends': (json['stipends'].map(StipendCreateDto_1.StipendCreateDtoFromJSON)),
    };
}
function SuggestedShiftRateDtoToJSON(json) {
    return SuggestedShiftRateDtoToJSONTyped(json, false);
}
function SuggestedShiftRateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'matchedOn': (0, SuggestedShiftRateMatch_1.SuggestedShiftRateMatchToJSON)(value['matchedOn']),
        'totalRate': value['totalRate'],
        'onCallTotalRate': value['onCallTotalRate'],
        'stipendMinimumDistance': value['stipendMinimumDistance'],
        'stipends': (value['stipends'].map(StipendCreateDto_1.StipendCreateDtoToJSON)),
    };
}
//# sourceMappingURL=SuggestedShiftRateDto.js.map